import qs from 'querystring'
import _ from 'underscore'

import Api from '../lib/request'
import { itemList } from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'

const getPayStatus = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
        query = `?${qs.stringify(queryData)}`
    }
    Api.get(COOKIECONSTANT.REQUEST_HOST + `${query}`, {
        headers: {
          'X-Host': 'mall.pay.pay-status',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        }
      })
      .then((data) => {
        if (data.status === 0) {
          return resolve(data)
        }
        return reject(data)
      }, (e) => {
        reject(e)
      })
  })
}
const getPayOrderAct = (queryData) => {
  return new Promise((resolve, reject) => {
    let query = ''
    if(!_.isEmpty(queryData)) {
      query = `?${qs.stringify(queryData)}`
    }
    Api.get(COOKIECONSTANT.REQUEST_HOST + query, {
      headers: {
        'X-host': 'mall.act.pay-order-act.detail',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
      }
    })
    .then(data => {
      if(data.status === 0) {
        return resolve(data.data)
      }
      return reject(data.msg)
    }, e => {
      reject(e)
    })
  })
}
/*yeoman-template-point-1*/
export default {
  getPayStatus,
  getPayOrderAct,
  /*yeoman-template-point-2*/
}
